import { CheckoutSession } from "../model/checkoutSession";
import { HttpFailedToFetchException } from "../model/httpException";
import { SubscriptionProduct } from "../model/subscriptionProduct";
import { getAuthHeaders } from "../utils/authHeaders";
import { logException } from "../utils/logUtils";
import { fetchWithRetry } from "../utils/retry.util";

export class StripeApi {
  private static readonly BASE_URL = import.meta.env.VITE_API_URL;
  private static readonly BASE_ENDPOINT = "stripe";

  static async loadProducts(): Promise<SubscriptionProduct[]> {
    const headers = await getAuthHeaders({});

    const response = await fetchWithRetry(
      `${this.BASE_URL}/${this.BASE_ENDPOINT}/paywall`,
      {
        method: "GET",
        headers,
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      logException("Stripe API error (/stripe/paywall):", {
        status: response.status,
        statusText: response.statusText,
        body: errorText,
      });
      throw new HttpFailedToFetchException();
    }

    const data = await response.json();

    return data.products;
  }

  static async createCheckoutSession(
    priceId: string
  ): Promise<CheckoutSession> {
    const headers = await getAuthHeaders({});

    const response = await fetchWithRetry(
      `${this.BASE_URL}/${
        this.BASE_ENDPOINT
      }/checkout?price_id=${priceId}&success_url=${encodeURIComponent(
        window.location.origin + "/subscription_success"
      )}&cancel_url=${encodeURIComponent(
        window.location.origin + "/subscription_failure"
      )}`,
      {
        method: "GET",
        headers,
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      logException("Stripe API error (/stripe/checkout):", {
        status: response.status,
        statusText: response.statusText,
        body: errorText,
      });
      throw new HttpFailedToFetchException();
    }

    const data = await response.json();

    return data;
  }

  static async loadUserPanelUrl(): Promise<string> {
    const headers = await getAuthHeaders({});

    const response = await fetchWithRetry(
      `${this.BASE_URL}/${
        this.BASE_ENDPOINT
      }/portal?return_url=${encodeURIComponent(window.location.href)}`,
      {
        method: "GET",
        headers,
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      logException("Stripe API error (/stripe/portal):", {
        status: response.status,
        statusText: response.statusText,
        body: errorText,
      });
      throw new HttpFailedToFetchException();
    }

    const data = await response.json();

    return data.url;
  }
}
